import script from "./ConfigurationRadioSelectionV3.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationRadioSelectionV3.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationRadioSelectionV3.vue?vue&type=style&index=0&id=1152eb8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1152eb8a"]])

export default __exports__